import { Box } from '@mui/material';
import { styled } from '@mui/styles';

export const AppLayout = styled(Box)({
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  maxWidth: '1960px',
  margin: '6.25rem auto 0 auto'
});
